import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';
class FileInput extends React.Component {
    constructor(props){
        super(props)
        this._handleChange = this._handleChange.bind(this)
        this.state = {
            name: 'Upload a file'
        }

    }
    _handleChange(event) {
        const reader = new FileReader()
        const file = event.target.files[0]
        reader.onloadend = () => {
            this.setState({name: file.name})
        }
        reader.readAsArrayBuffer(file)
    }

    render() {
        return(
            <Flex className={style.FileInputWrapper}>
                <input
                    onChange={this._handleChange}
                    className={style.FileInput + ' ' + this.props.className}
                    type="file"
                    id="file"
                />
                <label htmlFor="file" className={style.FileInputButton}>{this.state.name}</label>
            </Flex>
        );
    }
}


export default FileInput;



// WEBPACK FOOTER //
// src/component/Forms/FileInput/index.js